const Constant = {
    debug: true,
    image: 'https://globizcloudserver.com/techcruizer/public',
    host: 'https://globizcloudserver.com/techcruizer/public/api',
};

export default Constant;